export default "__VITE_ASSET__DTHEe9Ae__"